import { render } from "./DesignPage.vue?vue&type=template&id=0daf0829&scoped=true&ts=true"
import script from "./DesignPage.vue?vue&type=script&lang=ts"
export * from "./DesignPage.vue?vue&type=script&lang=ts"

import "./DesignPage.vue?vue&type=style&index=0&id=0daf0829&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0daf0829"]])

export default __exports__